import React from 'react'
import PartnerFaq from './PartnerFaq';
import PartnerFeature from './PartnerFeature';
import PartnerHero from './PartnerHero';
import PartnerList from './PartnerList';
import PartnerTestimonial from './PartnerTestimonial';
import PartnerTrust from './PartnerTrust';

const Partner = () => {
    return (
        <>
        <PartnerHero/>
        <PartnerTrust/>
        <PartnerFeature/>
        <PartnerList/>
        <PartnerFaq/>
        <PartnerTestimonial/>
        </>
    )
}

export default Partner;